import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {
    ENDPOINT_GET_ASSET_BY_ASSET_TYPE,
    ENDPOINT_ADD_ASSET,
    ENDPOINT_UPDATE_ASSET,
    ENDPOINT_SET_ASSET_STATUS,
    ENDPOINT_GET_ASSET_BY_ASSET_LABEL,
    ENDPOINT_GET_ASSETS_CONNECTIVITY,
    ENDPOINT_GET_ASSET_VERSIONS,
    ENDPOINT_GET_ASSET_BY_VERSION,
    ENDPOINT_UPDATE_ASSET_IN_PLACE,
    ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY
} from "../util/Constants";
import {getAPIGatewayPostRequest} from "../util/Util";

/**
 * Fetches an asset by calling appropriate end point.
 *
 * @returns {Promise<*>}
 * @param nodeId
 * @param assetType
 * @param pageToken
 */
export async function getAssets(nodeId, assetType, pageToken) {
    const requestBody = {
        nodeId: nodeId,
        assetType: assetType,
        pageToken: pageToken
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_ASSET_BY_ASSET_TYPE);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Adds asset by calling appropriate end point.
 *
 * @param asset
 * @returns {Promise<*>}
 */
export async function addAsset(asset) {
    const requestBody = {
        asset: asset
    }
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_ADD_ASSET);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Updates asset by calling appropriate end point.
 *
 * @param asset
 * @param creationTime
 * @returns {Promise<*>}
 */
export async function updateAsset(asset, creationTime) {
    const requestBody = {
        asset: asset,
        creationTime: creationTime
    }
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_UPDATE_ASSET);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Updates asset inplace by calling appropriate end point.
 *
 * @param asset
 * @param lastUpdateTime
 * @returns {Promise<*>}
 */
export async function updateAssetInPlace(asset, lastUpdateTime) {
    const requestBody = {
        asset: asset,
        lastUpdateTime: lastUpdateTime
    }
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_UPDATE_ASSET_IN_PLACE);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Deprecate asset by calling appropriate end point.
 *
 * @param assetLabel
 * @param status
 * @returns {Promise<*>}
 */
export async function setAssetStatus(assetLabel, status) {
    const requestBody = {
        assetLabel: assetLabel,
        assetStatus: status
    }
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_SET_ASSET_STATUS);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Fetches an asset by calling appropriate end point.
 *
 * @param assetLabel
 * @returns {Promise<*>}
 */
export async function getAssetByAssetLabel(assetLabel) {
    const requestBody = {
        assetLabel: assetLabel
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_ASSET_BY_ASSET_LABEL);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Fetches rollback versions for a particular device.
 *
 * @param mac
 * @returns {Promise<*>}
 */
export async function getAssetVersions(mac) {
    const requestBody = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_ASSET_VERSIONS);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Fetches rollback version asset for a particular version of a device.
 *
 * @param mac
 * @param rangeKey
 * @returns {Promise<*>}
 */
export async function getAssetByVersion(mac, rangeKey) {
    const requestBody = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        rangeKey
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_ASSET_BY_VERSION);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Fetches the connectivity status for assets on a site
 *
 * @param nodeId
 * @param assetType
 * @param deviceIdentifierList
 * @returns asset connectivity Response
 */
export async function getAssetsConnectivity(nodeId, assetType, deviceIdentifierList) {
    const request = {
        nodeId: nodeId,
        assetType: assetType,
        deviceIdentifierList: deviceIdentifierList
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ASSETS_CONNECTIVITY);
    const response = await getAPIGatewayDataFromParent(args);
    return response;
}

/**
 * Fetches the connectivity status for site devices on a site
 *
 * @param nodeId
 * @param deviceType
 * @param filters
 * @returns Site devices connectivity Response
 */
export async function getSiteDevicesConnectivity(nodeId, deviceType, filters) {
    const request = {
        nodeId: nodeId,
        deviceType: deviceType,
        filters: filters,
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY);
    const response = await getAPIGatewayDataFromParent(args);
    return response;
}



// WEBPACK FOOTER //
// ./src/components/resources/AssetResource.js